module.exports = __webpack_public_path__ + "static/favicon-da1ee734d943e8daa0979597389d3194.ico";